/**
 * equipment-unit API — a `equipment/01-unit-editor` read + Tab-1 PATCH kliens (seam #353/#354).
 *
 * A Zod-sémák (`@kgc/equipment-type-domain`) RUNTIME-validálják a választ/inputot → a mock-first FE
 * a pinnelt kontraktushoz illeszkedik (drift azonnal kiderül).
 * Route-align (#375 BE read-binding után): a kanonikus BE-route `api/v1/equipment-units` —
 * a GET a #375-tel él, a PATCH + POST /status response-align a Zeno következő körével.
 */
import { z } from 'zod';

import {
  equipmentUnitReadResponseSchema,
  equipmentUnitReadSchema,
  equipmentUnitStatusTransitionSchema,
  type EquipmentUnitEditorPatch,
  type EquipmentUnitRead,
  type EquipmentUnitStatusTransition,
} from '@kgc/equipment-type-domain';

import { api } from './client';

export async function getEquipmentUnit(id: string): Promise<EquipmentUnitRead> {
  const raw = await api.get<unknown>(`/equipment-units/${id}`);
  // runtime seam-validation a pinnelt Zod-kontraktusra (z.coerce.date a dátumokra)
  return equipmentUnitReadResponseSchema.parse(raw).data;
}

export async function updateEquipmentUnit(
  id: string,
  patch: EquipmentUnitEditorPatch
): Promise<EquipmentUnitRead> {
  const raw = await api.patch<unknown>(`/equipment-units/${id}`, patch);
  return equipmentUnitReadResponseSchema.parse(raw).data;
}

/**
 * Státusz-átmenet (domain-action) — `POST /equipment-units/:id/status`.
 * A `equipmentUnitStatusTransitionSchema` client-side is ellenőrzi a guardot (reason≥20 a
 * reason-required státuszoknál, ≥1 photoId DAMAGED-nél) → a hibás submit a hálózat előtt elbukik.
 */
export async function transitionEquipmentUnitStatus(
  id: string,
  dto: EquipmentUnitStatusTransition
): Promise<EquipmentUnitRead> {
  const validated = equipmentUnitStatusTransitionSchema.parse(dto);
  const raw = await api.post<unknown>(`/equipment-units/${id}/status`, validated);
  return equipmentUnitReadResponseSchema.parse(raw).data;
}

/**
 * Lean lista-item séma — a `GET /equipment-units?typeId=` a DOMAIN-shape-et adja
 * (NEM az enriched editor read-DTO-t: nincs typeName/statusHistory/images/documents),
 * ezért CSAK a lista-nézet mezőit pinneljük. Slice B (STORY-1306 P2 units-tab).
 */
export const equipmentUnitListItemSchema = z.object({
  id: z.string().uuid(),
  serialNumber: z.string(),
  assetTag: z.string().nullable(),
  status: equipmentUnitReadSchema.shape.status,
  createdAt: z.coerce.date(),
});
export type EquipmentUnitListItem = z.infer<typeof equipmentUnitListItemSchema>;

const equipmentUnitListResponseSchema = z.object({
  data: z.array(equipmentUnitListItemSchema),
});

/** A típushoz tartozó egységek (newest first a BE-rendezés szerint). */
export async function listEquipmentUnitsByType(typeId: string): Promise<EquipmentUnitListItem[]> {
  const raw = await api.get<unknown>(`/equipment-units?typeId=${encodeURIComponent(typeId)}`);
  return equipmentUnitListResponseSchema.parse(raw).data;
}
